export default __webpack_public_path__ + "static/media/newspapercutting.33bbe5d8.png";